// tarifsData.js - Centralized tariff data for all services
// FORCE_CACHE_BUST_20260315_143500
// Each plan can be customized with:
// - showRibbon: boolean - show/hide the ribbon
// - ribbonText: string - text on the ribbon (e.g. "BEST SELLER", "NEW", "POPULAIRE")
// - ribbonColor: string - background color of ribbon (e.g. "#DC2626" for red)
// - headerColor: string - background color of the header (e.g. "#1a1a1a" for black)
// - backgroundType: 'solid' | 'gradient' - type of card background
// - backgroundColor: string - solid background color (e.g. "#ffffff")
// - gradientColors: [string, string, string] - gradient colors [start, middle, end]
// - textColorOverride: string - override text color for the card (useful for gradient backgrounds)

export const DEFAULT_PHOTOBOOTH_TARIFS = [
  {
    id: 'numerique',
    name: 'La Numérique',
    duration: '3h',
    price: 149,
    popular: false,
    color: '#A8A9AD',
    showRibbon: false,
    ribbonText: '',
    ribbonColor: '#DC2626',
    headerColor: '#1a1a1a',
    backgroundType: 'solid',
    backgroundColor: '#ffffff',
    features: [
      'Photos numériques en illimité (SANS IMPRESSION)',
      '1 modèle personnalisé inclus',
      'Galerie en ligne sécurisée',
      'Récupération instantanée via QR Code (si connexion 4G/WIFI sur le lieu de l\'événement)',
      'Livraison, installation et désinstallation',
      'Assistance 24/24 & 7/7',
      'Frais kilométriques facturés au-delà de 25km de nos entrepôts',
    ],
    summary: 'SANS IMPRESSION',
    prints_count: 0,
    prints_unlimited: false,
  },
  {
    id: 'classique',
    name: 'La Classique',
    duration: '4h',
    price: 249,
    popular: false,
    color: '#CD7F32',
    showRibbon: false,
    ribbonText: '',
    ribbonColor: '#DC2626',
    headerColor: '#C9A45C',
    backgroundType: 'solid',
    backgroundColor: '#ffffff',
    features: [
      '200 photos imprimées haute qualité',
      'Photos numériques en illimité',
      '1 modèle personnalisé inclus',
      'Galerie en ligne sécurisée',
      'Récupération instantanée via QR Code (si connexion 4G/WIFI sur le lieu de l\'événement)',
      'Livraison, installation et désinstallation',
      'Assistance 24/24 & 7/7',
      'Frais kilométriques facturés au-delà de 25km de nos entrepôts',
    ],
    summary: '200 impressions',
    prints_count: 200,
  },
  {
    id: 'premium',
    name: 'La Premium',
    duration: '6h',
    price: 349,
    popular: false,
    color: '#FFD700',
    showRibbon: false,
    ribbonText: '',
    ribbonColor: '#DC2626',
    headerColor: '#1a1a1a',
    backgroundType: 'solid',
    backgroundColor: '#ffffff',
    features: [
      '400 photos imprimées haute qualité',
      'Photos numériques en illimité',
      '2 modèles personnalisés inclus',
      'Galerie en ligne sécurisée',
      'Récupération instantanée via QR Code (si connexion 4G/WIFI sur le lieu de l\'événement)',
      'Livraison, installation et désinstallation',
      'Assistance 24/24 & 7/7',
      'Frais kilométriques facturés au-delà de 25km de nos entrepôts',
    ],
    summary: '400 impressions',
    prints_count: 400,
    templates_count: 2,
  },
  {
    id: 'vip',
    name: 'La VIP',
    duration: '24h max',
    price: 399,
    popular: true,
    color: '#B76E79',
    // VIP Photobooth: RED gradient like reference site
    showRibbon: true,
    ribbonText: 'BEST SELLER',
    ribbonColor: '#DC2626',
    headerColor: '#8B0000',
    backgroundType: 'gradient',
    gradientColors: ['#C41E3A', '#8B0000', '#5C0A0A'], // RED GRADIENT
    textColorOverride: '#ffffff',
    features: [
      '400 photos imprimées haute qualité',
      'Photos numériques en illimité',
      'Durée illimitée (max 24h)',
      '2 modèles personnalisés inclus',
      'Galerie en ligne sécurisée',
      'Récupération instantanée via QR Code (si connexion 4G/WIFI sur le lieu de l\'événement)',
      'Livraison, installation et désinstallation',
      'Frais kilométriques OFFERTS',
      'Clé USB offerte',
      'Assistance 24/24 & 7/7',
    ],
    summary: '400 impressions',
    prints_count: 400,
    templates_count: 2,
    km_offerts: true,
    usb_included: true,
    bonus: ['Frais kilométriques OFFERTS', 'CLÉ USB OFFERTE'],
  },
];

export const DEFAULT_VIDEOBOOTH_80CM_TARIFS = [
  {
    id: '360-standard',
    name: 'La 360 Standard',
    duration: '2h',
    price: 349,
    subtitle: 'Plateforme 80cm - de 1 à 3 personnes',
    popular: false,
    color: '#C0C0C0',
    showRibbon: false,
    ribbonText: '',
    ribbonColor: '#DC2626',
    headerColor: '#1a1a1a',
    backgroundType: 'solid',
    backgroundColor: '#ffffff',
    features: [
      'Vidéos 360° illimitées',
      '1 modèle personnalisé inclus',
      '1 musique au choix',
      'Galerie vidéo sécurisée',
      'Animateurs présents sur place',
      'Partage instantané (QR/AirDrop/SMS/Mail)',
      'Accessoires + pistolets à bulles',
      'Livraison, installation et désinstallation',
      'Frais kilométriques facturés au-delà de 25km de nos entrepôts',
      'Assistance 24/24 & 7/7',
    ],
    summary: '1 modèle, 1 musique',
  },
  {
    id: '360-gala',
    name: 'La 360 Gala',
    duration: '3h',
    price: 399,
    subtitle: 'Plateforme 80cm - de 1 à 3 personnes',
    popular: false,
    color: '#B87333',
    showRibbon: false,
    ribbonText: '',
    ribbonColor: '#DC2626',
    headerColor: '#C9A45C',
    backgroundType: 'solid',
    backgroundColor: '#ffffff',
    features: [
      'Vidéos 360° illimitées',
      '1 modèle personnalisé inclus',
      '1 musique au choix',
      'Galerie vidéo sécurisée',
      'Animateurs présents sur place',
      'Partage instantané (QR/AirDrop/SMS/Mail)',
      'Accessoires + pistolets à bulles + pistolets à billets',
      'Livraison, installation et désinstallation',
      'Frais kilométriques facturés au-delà de 25km de nos entrepôts',
      'Assistance 24/24 & 7/7',
    ],
    summary: '1 modèle, 1 musique',
  },
  {
    id: '360-prestige',
    name: 'La 360 Prestige',
    duration: '4h',
    price: 449,
    subtitle: 'Plateforme 80cm - de 1 à 3 personnes',
    popular: false,
    color: '#CFB53B',
    showRibbon: false,
    ribbonText: '',
    ribbonColor: '#DC2626',
    headerColor: '#1a1a1a',
    backgroundType: 'solid',
    backgroundColor: '#ffffff',
    features: [
      'Vidéos 360° illimitées',
      '1 modèle personnalisé inclus',
      '1 musique au choix',
      'Galerie vidéo sécurisée',
      'Animateurs présents sur place',
      'Partage instantané (QR/AirDrop/SMS/Mail)',
      'Accessoires + pistolets à bulles + pistolets à billets + ventilateur studio',
      'Livraison, installation et désinstallation',
      'Frais kilométriques facturés au-delà de 25km de nos entrepôts',
      'Assistance 24/24 & 7/7',
    ],
    summary: '1 modèle, 1 musique',
  },
  {
    id: '360-luxe',
    name: 'La 360 Luxe',
    duration: '6h',
    price: 499,
    subtitle: 'Plateforme 80cm - de 1 à 3 personnes',
    popular: true,
    color: '#D4AF37',
    // Most expensive = BEST SELLER with GOLD gradient
    showRibbon: true,
    ribbonText: 'BEST SELLER',
    ribbonColor: '#DC2626',
    headerColor: '#C9A45C',
    backgroundType: 'gradient',
    gradientColors: ['#D4A574', '#C9A45C', '#B8956F'], // GOLD GRADIENT
    textColorOverride: '#ffffff',
    features: [
      'Vidéos 360° illimitées',
      '2 modèles personnalisés inclus',
      '2 musiques au choix',
      'Galerie vidéo sécurisée',
      'Animateurs présents sur place',
      'Partage instantané (QR/AirDrop/SMS/Mail)',
      'Tous les accessoires + machine à fumée',
      'Livraison, installation et désinstallation',
      'Frais kilométriques facturés au-delà de 25km de nos entrepôts',
      'Assistance 24/24 & 7/7',
    ],
    summary: '2 modèles, 2 musiques',
  },
];

export const DEFAULT_VIDEOBOOTH_100CM_TARIFS = [
  {
    id: '360-standard-plus',
    name: '360 STANDARD PLUS',
    duration: '2h',
    price: 399,
    subtitle: 'Plateforme 100cm - de 1 à 5 personnes',
    popular: false,
    color: '#C0C0C0',
    showRibbon: false,
    ribbonText: '',
    ribbonColor: '#DC2626',
    headerColor: '#1a1a1a',
    backgroundType: 'solid',
    backgroundColor: '#ffffff',
    features: [
      'Vidéos 360° illimitées',
      '1 modèle personnalisé inclus',
      '1 musique au choix',
      'Galerie vidéo sécurisée',
      'Animateurs présents sur place',
      'Partage instantané (QR/AirDrop/SMS/Mail)',
      'Accessoires + pistolets à bulles',
      'Livraison, installation et désinstallation',
      'Frais kilométriques facturés au-delà de 25km de nos entrepôts',
      'Assistance 24/24 & 7/7',
    ],
    summary: '1 modèle, 1 musique',
  },
  {
    id: '360-gala-plus',
    name: '360 GALA PLUS',
    duration: '3h',
    price: 449,
    subtitle: 'Plateforme 100cm - de 1 à 5 personnes',
    popular: false,
    color: '#B87333',
    showRibbon: false,
    ribbonText: '',
    ribbonColor: '#DC2626',
    headerColor: '#C9A45C',
    backgroundType: 'solid',
    backgroundColor: '#ffffff',
    features: [
      'Vidéos 360° illimitées',
      '1 modèle personnalisé inclus',
      '1 musique au choix',
      'Galerie vidéo sécurisée',
      'Animateurs présents sur place',
      'Partage instantané (QR/AirDrop/SMS/Mail)',
      'Accessoires + pistolets à bulles + pistolets à billets',
      'Livraison, installation et désinstallation',
      'Frais kilométriques facturés au-delà de 25km de nos entrepôts',
      'Assistance 24/24 & 7/7',
    ],
    summary: '1 modèle, 1 musique',
  },
  {
    id: '360-prestige-plus',
    name: '360 PRESTIGE PLUS',
    duration: '4h',
    price: 499,
    subtitle: 'Plateforme 100cm - de 1 à 5 personnes',
    popular: false,
    color: '#CFB53B',
    showRibbon: false,
    ribbonText: '',
    ribbonColor: '#DC2626',
    headerColor: '#1a1a1a',
    backgroundType: 'solid',
    backgroundColor: '#ffffff',
    features: [
      'Vidéos 360° illimitées',
      '1 modèle personnalisé inclus',
      '1 musique au choix',
      'Galerie vidéo sécurisée',
      'Animateurs présents sur place',
      'Partage instantané (QR/AirDrop/SMS/Mail)',
      'Accessoires + pistolets à bulles + pistolets à billets + ventilateur studio',
      'Livraison, installation et désinstallation',
      'Frais kilométriques facturés au-delà de 25km de nos entrepôts',
      'Assistance 24/24 & 7/7',
    ],
    summary: '1 modèle, 1 musique',
  },
  {
    id: '360-luxe-plus',
    name: '360 LUXE PLUS',
    duration: '6h',
    price: 549,
    subtitle: 'Plateforme 100cm - de 1 à 5 personnes',
    popular: true,
    color: '#D4AF37',
    showRibbon: true,
    ribbonText: 'BEST SELLER',
    ribbonColor: '#DC2626',
    headerColor: '#C9A45C',
    backgroundType: 'gradient',
    gradientColors: ['#D4A574', '#C9A45C', '#B8956F'], // GOLD GRADIENT
    textColorOverride: '#ffffff',
    features: [
      'Vidéos 360° illimitées',
      '2 modèles personnalisés inclus',
      '2 musiques au choix',
      'Galerie vidéo sécurisée',
      'Animateurs présents sur place',
      'Partage instantané (QR/AirDrop/SMS/Mail)',
      'Tous les accessoires + machine à fumée',
      'Livraison, installation et désinstallation',
      'Frais kilométriques facturés au-delà de 25km de nos entrepôts',
      'Assistance 24/24 & 7/7',
    ],
    summary: '2 modèles, 2 musiques',
  },
];

export const DEFAULT_LIVREOR_TARIFS = [
  {
    id: 'livreor-essentiel',
    name: 'Livre d\'Or Vidéo Essentiel',
    duration: '4h',
    price: 299,
    popular: false,
    color: '#C0C0C0',
    showRibbon: false,
    ribbonText: '',
    ribbonColor: '#DC2626',
    headerColor: '#1a1a1a',
    backgroundType: 'solid',
    backgroundColor: '#ffffff',
    features: [
      'Messages vidéo illimités',
      'Enregistrement 4K fluide',
      'Micro professionnel col de cygne',
      'Pupitre élégant',
      'Éclairage LED optimal',
      'Interface personnalisable',
      'Galerie vidéo sécurisée',
      'Livraison, installation et désinstallation',
      'Frais kilométriques facturés au-delà de 25km de nos entrepôts',
      'Assistance 24/24 & 7/7',
    ],
  },
  {
    id: 'livreor-infinity',
    name: 'Livre d\'Or Vidéo Infinity',
    duration: '24h max',
    price: 399,
    popular: true,
    color: '#D4AF37',
    showRibbon: true,
    ribbonText: 'BEST SELLER',
    ribbonColor: '#DC2626',
    headerColor: '#C9A45C',
    backgroundType: 'gradient',
    gradientColors: ['#D4A574', '#C9A45C', '#B8956F'], // GOLD GRADIENT
    textColorOverride: '#ffffff',
    features: [
      'Messages vidéo illimités',
      'Durée illimitée (max 24h)',
      'Enregistrement 4K fluide',
      'Micro professionnel col de cygne',
      'Pupitre élégant',
      'Éclairage LED optimal',
      'Interface 100% personnalisable',
      'Montage compilé avec musique',
      'Galerie vidéo sécurisée',
      'Livraison, installation et désinstallation',
      'Frais kilométriques OFFERTS',
      'Assistance 24/24 & 7/7',
    ],
  },
];

// Keep old variable name for backward compatibility
export const DEFAULT_VIDEOBOOTH_TARIFS = DEFAULT_VIDEOBOOTH_80CM_TARIFS;
